module.exports = [
    {src:'./img/slider/animation/dress.png', id:'dress'},
    {src:'./img/slider/animation/GRID.png', id:'GRID'},
    {src:'./img/slider/animation/grid_2_1.png', id:'grid_2_1'},
    {src:'./img/slider/animation/grid_2_2.png', id:'grid_2_2'},
    {src:'./img/slider/animation/grid_3_1.png', id:'grid_3_1'},
    {src:'./img/slider/animation/grid_3_2.png', id:'grid_3_2'},
    {src:'./img/slider/animation/grid_4.png', id:'grid_4'},
    {src:'./img/slider/animation/hands.png', id:'hands'},
    {src:'./img/slider/animation/pic_2.png', id:'pic_2'},
    {src:'./img/slider/animation/pic_3.png', id:'pic_3'},
    {src:'./img/slider/animation/pic_4.png', id:'pic_4'},
    {src:'./img/slider/animation/white.png', id:'white'},
    {src:'./img/slider/animation/white_2.png', id:'white_2'},
    {src:'./img/slider/animation/white_3.png', id:'white_3'},
    {src:'./img/slider/animation/white_4.png', id:'white_4'}
];


// WEBPACK FOOTER //
// ./js/animation/MBFWR_Covers_Manifest.js